module.exports = __webpack_public_path__ + "img/user-banner.23be778f.png";